"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
var SvgCopy = function SvgCopy(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.458 8.183c0-1.967.067-3.405.137-4.376a2.367 2.367 0 0 1 2.211-2.211 60.97 60.97 0 0 1 4.376-.138c1.967 0 3.405.067 4.376.138a2.367 2.367 0 0 1 2.211 2.21l.018.254a72.062 72.062 0 0 0-2.97-.057 61.88 61.88 0 0 0-4.455.14 3.457 3.457 0 0 0-3.22 3.22c-.072.999-.14 2.463-.14 4.454 0 1.167.023 2.153.057 2.97a38.743 38.743 0 0 1-.253-.017 2.367 2.367 0 0 1-2.21-2.211 60.68 60.68 0 0 1-.138-4.376Zm3.635 3.634c0-1.966.066-3.404.137-4.376a2.367 2.367 0 0 1 2.211-2.21 60.68 60.68 0 0 1 4.376-.138c1.967 0 3.404.067 4.376.137a2.367 2.367 0 0 1 2.211 2.211 61 61 0 0 1 .137 4.376 61 61 0 0 1-.137 4.376 2.367 2.367 0 0 1-2.211 2.211 61 61 0 0 1-4.376.138c-1.967 0-3.404-.067-4.376-.138a2.367 2.367 0 0 1-2.211-2.21c-.07-.972-.137-2.41-.137-4.377Z",
    fill: "#FF611D"
  }));
};
var Memo = /*#__PURE__*/(0, _react.memo)(SvgCopy);
var _default = exports["default"] = Memo;